import React from 'react';
import css from './PodcastPlatforms.module.scss';
import { StaticImage } from 'gatsby-plugin-image';

import ExternalLink from '@components/ExternalLink/ExternalLink';
import Link from '@components/Link/Link';

const defaultLinks = {
  twoSided: {
    apple: 'https://podcasts.apple.com/fi/podcast/two-sided-the-marketplace-podcast/id1517378177',
    spotify: 'https://open.spotify.com/show/5GV4MNN8celP0aMC0tfehC',
    youtube: 'https://www.youtube.com/playlist?list=PLR1RSq0D3b5B7gW87vaO_mjSOW-fjxEkD',
  },
  marketplaceAcademy: {
    apple: 'https://podcasts.apple.com/gb/podcast/marketplace-academy/id1616828405',
    spotify: 'https://open.spotify.com/show/4NgJKSp2ay8cST4cLszvTl',
    youtube: 'https://www.youtube.com/playlist?list=PLR1RSq0D3b5DUHVMMSg25AUSpFkrQ71Ki',
  },
};

const defaultRootLink = {
  twoSided: '/twosided/',
  marketplaceAcademy: '/academy/marketplace-academy-podcast/',
};

const PodcastPlatforms = ({
  apple,
  spotify,
  youtube,
  type = 'twoSided',
  showAllEpisodesLink = false,
}) => {
  return (
    <section className={css.logos}>
      <p className={css.small} style={{ textAlign: 'center' }}>
        Listen on your favorite platform
      </p>
      <ul>
        <ExternalLink href={apple || defaultLinks[type]?.apple}>
          <li>
            <StaticImage
              objectFit="contain"
              src="../../images/logos/PodcastPlatforms/applepodcasts.png"
              alt="Listen to Two-Sided on Apple Podcasts"
            />
          </li>
        </ExternalLink>
        <ExternalLink href={spotify || defaultLinks[type]?.spotify}>
          <li>
            <StaticImage
              src="../../images/logos/PodcastPlatforms/spotifypodcasts.png"
              alt="Listen to Two-Sided on Spotify"
            />
          </li>
        </ExternalLink>
        <ExternalLink href={youtube || defaultLinks[type]?.youtube}>
          <li>
            <StaticImage
              src="../../images/logos/PodcastPlatforms/youtubepodcasts.png"
              alt="Listen to Two-Sided on Youtube"
            />
          </li>
        </ExternalLink>
      </ul>
      {showAllEpisodesLink && defaultRootLink[type] ? (
        <p className={css.allEpisodesLink}>
          <Link to={defaultRootLink[type]}>See all episodes</Link>
        </p>
      ) : null}
    </section>
  );
};

export default PodcastPlatforms;
